// extracted by mini-css-extract-plugin
module.exports = {"requestButton":"FacebookAppAccess_requestButton_3kK-L","error":"FacebookAppAccess_error_3E7pm"};